(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["search-results.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros.njk", false, "search-results.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "search_result")) {
var t_4 = t_1.search_result;
} else {
cb(new Error("cannot import 'search_result'")); return;
}
context.setVariable("search_result", t_4);
output += "\n\n<section class=\"mzp-l-content sumo-page-section--inner\">\n  <div id=\"search-results\" class=\"sumo-l-two-col\">\n    <aside class=\"sumo-l-two-col--sidebar\">\n      <h3 class=\"sidebar-subheading\">";
output += runtime.suppressValue((lineno = 5, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Filter by product"])), env.opts.autoescape);
output += "</h3>\n      <nav class=\"sidebar-nav\">\n      <a class=\"details-heading\">Menu Title</a>\n      <ul id=\"product-filter\" class=\"search-filter sidebar-nav--list\">\n        <li ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, runtime.contextOrFrameLookup(context, frame, "product"),runtime.contextOrFrameLookup(context, frame, "undefined")), env.opts.autoescape);
output += ">\n          <a href=\"#\" data-instant-search-unset-params=\"product&page\" data-instant-search-set-params=\"all_products=1\" data-instant-search=\"link\">\n            ";
output += runtime.suppressValue((lineno = 11, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["All Products"])), env.opts.autoescape);
output += "\n          </a>\n        </li>\n        ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "products");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("p", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n          <li ";
output += runtime.suppressValue(env.getFilter("class_selected").call(context, runtime.contextOrFrameLookup(context, frame, "product"),runtime.memberLookup((t_8),"slug")), env.opts.autoescape);
output += ">\n            <a href=\"#\" data-instant-search-set-params=\"product=";
output += runtime.suppressValue(runtime.memberLookup((t_8),"slug"), env.opts.autoescape);
output += "\" data-instant-search-unset-params=\"all_products&page\" data-instant-search=\"link\">\n              ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "\n            </a>\n          </li>\n        ";
;
}
}
frame = frame.pop();
output += "\n      </ul>\n      </nav>\n    </aside>\n\n    <main class=\"sumo-l-two-col--main\" id=\"search-results-list\">\n      ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("search-results-list.njk", false, "search-results.njk", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
callback(null,t_9);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
callback(null,t_11);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </main>\n  </div>\n</section>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
